import type { TOC } from '@ember/component/template-only';
import type { Task } from 'ember-concurrency';
import type ConnectLocationConfigurationModel from 'garaje/models/connect-location-configuration';
import type LocationModel from 'garaje/models/location';
import type UserModel from 'garaje/models/user';

import Visitor from './visitor';
import WalkIn from './walk-in';

interface ConnectNotificationsSignature {
  Args: {
    location: LocationModel;
    searchUsersTask: Task<UserModel[], [term: string, contacts: UserModel[]]>;
    connectLocationConfiguration?: ConnectLocationConfigurationModel;
  };
  Element: HTMLDivElement;
}

export default <template>
  <h3>Connect notifications</h3>

  <Visitor @location={{@location}} @searchUsersTask={{@searchUsersTask}} />

  {{#if @connectLocationConfiguration}}
    <WalkIn
      @location={{@location}}
      @searchUsersTask={{@searchUsersTask}}
      @connectLocationConfiguration={{@connectLocationConfiguration}}
    />
  {{/if}}
</template> satisfies TOC<ConnectNotificationsSignature>;
